import apiClient from './client';

export const portfolioApi = {
  /**
   * Get all portfolios
   */
  getPortfolios: async () => {
    const response = await apiClient.get('/api/portfolio');
    return response.data;
  },

  /**
   * Get a single portfolio by ID
   */
  getPortfolio: async (id) => {
    const response = await apiClient.get(`/api/portfolio/${id}`);
    return response.data;
  },

  /**
   * Create a new portfolio
   */
  createPortfolio: async (name, description = null, cash = 0) => {
    const response = await apiClient.post('/api/portfolio', { name, description, cash });
    return response.data;
  },

  /**
   * Update a portfolio
   */
  updatePortfolio: async (id, name, description = null, cash = null) => {
    const response = await apiClient.put(`/api/portfolio/${id}`, { name, description, cash });
    return response.data;
  },

  /**
   * Delete a portfolio
   */
  deletePortfolio: async (id) => {
    const response = await apiClient.delete(`/api/portfolio/${id}`);
    return response.data;
  },

  /**
   * Get all stocks in a portfolio
   */
  getPortfolioStocks: async (portfolioId) => {
    const response = await apiClient.get(`/api/portfolio/${portfolioId}/stocks`);
    return response.data;
  },

  /**
   * Add a stock to a portfolio
   */
  addStock: async (portfolioId, symbol, quantity, buyPrice, buyDate = null, notes = null) => {
    const response = await apiClient.post(`/api/portfolio/${portfolioId}/stocks`, {
      symbol,
      quantity,
      buyPrice,
      buyDate,
      notes,
    });
    return response.data;
  },

  /**
   * Update a stock in a portfolio
   */
  updateStock: async (portfolioId, stockId, symbol, quantity, buyPrice, buyDate = null, notes = null) => {
    const response = await apiClient.put(`/api/portfolio/${portfolioId}/stocks/${stockId}`, {
      symbol,
      quantity,
      buyPrice,
      buyDate,
      notes,
    });
    return response.data;
  },

  /**
   * Remove a stock from a portfolio
   */
  removeStock: async (portfolioId, stockId) => {
    const response = await apiClient.delete(`/api/portfolio/${portfolioId}/stocks/${stockId}`);
    return response.data;
  },

  /**
   * Calculate current portfolio value
   */
  getPortfolioValue: async (portfolioId) => {
    const response = await apiClient.get(`/api/portfolio/${portfolioId}/value`);
    return response.data;
  },

  /**
   * Create a daily snapshot of portfolio value
   */
  createSnapshot: async (portfolioId) => {
    const response = await apiClient.post(`/api/portfolio/${portfolioId}/snapshot`);
    return response.data;
  },

  /**
   * Get portfolio snapshots (daily tracking data)
   */
  getSnapshots: async (portfolioId, startDate = null, endDate = null) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const url = `/api/portfolio/${portfolioId}/snapshots${params.toString() ? '?' + params.toString() : ''}`;
    const response = await apiClient.get(url);
    return response.data;
  },
};

